// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"8b17cb76","70":"ac83efc6","288":"e1b0ada8"}[chunkId] + ".chunk.js";
};